import styled from 'styled-components';
import { IconSizesType } from '../ThemeProvider/types';

export const SpinnerContainer = styled.div<{
  size: IconSizesType;
}>`
  width: ${({ theme, size }) => theme.basicIcon[size].size - 3}px;
  height: ${({ theme, size }) => theme.basicIcon[size].size - 3}px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: auto !important;

  & > svg path,
  & > svg circle,
  & > svg rect {
    stroke-width: ${({ theme, size }) => theme.basicIcon[size].stroke}px;
  }
`;

export const Icon = styled.div<{ disabled: boolean }>`
  & > div {
    cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
  }
`;
